import {
  Text,
  Button,
  ChevronDownIcon,
  MenuButton,
  Flex,
  MenuButtonProps,
} from '@cdl/heartbeat-react';
import { FrozenMarker } from '../../../features/diagnostic/components/FrozenMarker';
import { DateTime } from 'luxon';

type Props = {
  expertName: string;
  updatedAt?: string;
  immutable?: boolean;
} & MenuButtonProps;

export const CustomMenuButton: React.FC<Props> = ({
  expertName,
  updatedAt,
  immutable = false,
  ...rest
}) => {
  return (
    <MenuButton
      as={Button}
      rightIcon={<ChevronDownIcon />}
      variant='secondary'
      textAlign='left'
      fontWeight='regular'
      w='full'
      {...rest}
    >
      <Flex justify='space-between' align='center'>
        <Text overflow='hidden' whiteSpace='nowrap' textOverflow='ellipsis'>
          {expertName}
        </Text>
        {updatedAt && (
          <Text fontSize='xs' px='s'>
            {DateTime.fromISO(updatedAt).toLocaleString()}
          </Text>
        )}
        {immutable && <FrozenMarker />}
      </Flex>
    </MenuButton>
  );
};
